import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { bridgeportConfig } from "./data";

export default function BridgeportPage() {
  return <CityPageTemplate config={bridgeportConfig} />;
}